export default __webpack_public_path__ + "static/media/hoteldelux2.d1558ce5.jpg";